import { TFunction } from 'i18next';
import { v4 as uuidV4 } from 'uuid';
import * as yup from 'yup';

import { WorkspaceType } from '~/scenes/MyWorkspace/data';
import { WorkspaceSettings } from '~/scenes/MyWorkspace/userSettings';
import { RoleGroups } from '~/services/Permissions';

export enum WorkspaceSetupMode {
  Create = 'create',
  Duplicate = 'duplicate',
}

export type WorkspaceSetupFormSettings = {
  mode: WorkspaceSetupMode;
  payload: WorkspaceSettings;
};

export const WorkspaceTemplate_Empty = 'EMPTY';
export type WorkspaceTemplate = RoleGroups | 'EMPTY';

export const getEmptyWorkspaceSettings = (): WorkspaceSettings => {
  return {
    id: WorkspaceTemplate_Empty,
    name: '',
    widgets: [],
    type: WorkspaceType.Default,
    restrictToRoles: [],
  };
};

export const initializeNewWorkspace = (
  workspaceSettings: WorkspaceSettings,
): WorkspaceSettings => {
  return {
    ...workspaceSettings,
    id: uuidV4(),
  };
};

export const yupValidateWorkspaceName = (
  workspaces: WorkspaceSettings[],
  manageWorkspaceId: string | undefined,
  t: TFunction,
) => {
  return yup
    .string()
    .required(t('fieldIsRequired'))
    .max(80, t('fieldMaxLength', { limit: 80 }))
    .test(
      'unique',
      t('fieldMustBeUnique', {
        field: t('workspaceName'),
      }),
      (value) => {
        return (
          !value ||
          !workspaces.some(({ id, name }) => {
            return (
              value.toLowerCase() === name.toLowerCase() &&
              id !== manageWorkspaceId
            );
          })
        );
      },
    );
};
